<template>
  <div class="el-col-24">
    <h5 class="warp-title">首页</h5>
  </div>
</template>

<script>
export default {
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Index/Index.vue